/**
 * @param {number} price
 * @param {Object} coupon
 */
export default function getCouponDiscount(price, coupon) {
  let discount = 0;

  if (coupon) {
    if (coupon.amountOff) {
      discount = coupon.amountOff;
    }

    if (coupon.percentOff) {
      discount = price - price * (1 - coupon.percentOff / 100);
    }
  }

  return discount;
}
